var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDangerous(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99562 4.81936C8.86876 3.24771 11.129 3.24772 12.0022 4.81936L17.503 14.7208C18.3516 16.2483 17.2471 18.1254 15.4997 18.1254H4.49809C2.75073 18.1254 1.64622 16.2483 2.49481 14.7208L7.99562 4.81936ZM10.6239 8.33375C10.6239 7.98857 10.3441 7.70875 9.99889 7.70875C9.65371 7.70875 9.37389 7.98857 9.37389 8.33375V11.6671C9.37389 12.0123 9.65371 12.2921 9.99889 12.2921C10.3441 12.2921 10.6239 12.0123 10.6239 11.6671V8.33375ZM9.99889 14.3754C9.65371 14.3754 9.37389 14.6552 9.37389 15.0004C9.37389 15.3456 9.65371 15.6254 9.99889 15.6254H10.0064C10.3516 15.6254 10.6314 15.3456 10.6314 15.0004C10.6314 14.6552 10.3516 14.3754 10.0064 14.3754H9.99889Z",
    fill: "#D802BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDangerous);
export default __webpack_public_path__ + "static/media/icon_dangerous.766f2985ff291d02863564d831925aac.svg";
export { ForwardRef as ReactComponent };